import { render, staticRenderFns } from "./PerformanceCard.vue?vue&type=template&id=ce461846"
import script from "./PerformanceCard.vue?vue&type=script&lang=js"
export * from "./PerformanceCard.vue?vue&type=script&lang=js"
import style0 from "./PerformanceCard.vue?vue&type=style&index=0&id=ce461846&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports